import React, { type FC } from 'react'

import { useIntl } from 'react-intl'

import { NoResults } from 'mailup-web-components'

const PreviewNoResults: FC = () => {
  const intl = useIntl()

  return (
    <NoResults
      margin="0"
      text={intl.formatMessage({
        id: 'Load.RecipientsList.ModalBulkFindReplaceNoResults',
      })}
    />
  )
}

export default PreviewNoResults
